export default __webpack_public_path__ + "static/media/arrival6.d0b9c3d6.png";